import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { rootStore } from '../../../../mobx/rootStore';

interface UseSettingNavbarListenersProps {
  setAlertModalOpen: (open: boolean) => void;
  setNavigatePath: (path: string) => void;
  setUpdatedDataName: (name: string) => void;
}

export const useSettingNavbarListeners = ({
  setAlertModalOpen,
  setNavigatePath,
  setUpdatedDataName
}: UseSettingNavbarListenersProps) => {
  const history = useHistory();
  const location = useLocation();
  const prevLocation = location.pathname;

  const { projectTemplateStore, settingStore } = rootStore;
  const { currentProjectTemplate } = projectTemplateStore;
  const { notificationSettingDetails } = settingStore;

  useEffect(() => {
    const unListen = history.listen((location) => {
      if (currentProjectTemplate?.updated && location.pathname !== prevLocation) {
        setUpdatedDataName('projectTemplateDetails');
        history.push(prevLocation);
        setAlertModalOpen(true);
        setNavigatePath(location.pathname);
      } else if (notificationSettingDetails.updated && location.pathname !== prevLocation) {
        setUpdatedDataName('notificationSettingDetails');
        history.push(prevLocation);
        setAlertModalOpen(true);
        setNavigatePath(location.pathname);
      }
    });
    return () => {
      unListen();
    };
  }, [
    history,
    notificationSettingDetails.updated,
    prevLocation,
    currentProjectTemplate?.updated,
    setAlertModalOpen,
    setNavigatePath,
    setUpdatedDataName
  ]);

  return {
    prevLocation
  };
};
